import { render } from "./PatternBg.vue?vue&type=template&id=5d4f31b8"
import script from "./PatternBg.vue?vue&type=script&lang=js"
export * from "./PatternBg.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__